import moment from 'moment';
import i18n from 'src/i18n';

const emptyHeader = '';

export const getTableHeaders = () => [
  i18n.t('table headers.full name', { ns: 'history' }),
  i18n.t('table headers.internal id', { ns: 'history' }),
  i18n.t('table headers.personal id', { ns: 'history' }),
  i18n.t('table headers.tax id', { ns: 'history' }),
  i18n.t('table headers.request date', { ns: 'history' }),
  i18n.t('table headers.status', { ns: 'history' }),
  emptyHeader
];

export const datePrettifier = (date: Date | string, format = 'DD/MM/YYYY, HH:mm:ss') => moment(date).format(format);
